





'use strict';







var helpers = {







    cinema: function(video, poster) {

        if (typeof poster === 'undefined') {
            poster = false;
        }


        var
            cinemaHTML,
            populateCinemaCaptions,
            populateCinemaDescription,
            populateCinemaTranscript,
            utilMergeObjects,
            cinemaCaptionAnnotations,
            checkForNonCTACaptions;






        cinemaCaptionAnnotations = {






            style: {
                standard: "spa-cinema-captions--standard",
                custom: "spa-cinema-captions--custom"
            },





            x: {
                full: 'spa-cinema-caption--vid-full-x',
                half: 'spa-cinema-caption--vid-half-x',
                third: 'spa-cinema-caption--vid-third-x',
                quater: 'spa-cinema-caption--vid-quater-x',
                slim: 'spa-cinema-caption--vid-slim-x'
            },





            y: {
                full: 'spa-cinema-caption--vid-full-y',
                half: 'spa-cinema-caption--vid-half-y',
                third: 'spa-cinema-caption--vid-third-y',
                quater: 'spa-cinema-caption--vid-quater-y',
                slim: 'spa-cinema-caption--vid-slim-y'
            },





            position: {
                top: 'spa-cinema-caption--vid-top',
                middle: 'spa-cinema-caption--vid-middle',
                bottom: 'spa-cinema-caption--vid-bottom',
                left: 'spa-cinema-caption--vid-left',
                right: 'spa-cinema-caption--vid-right',
                center: 'spa-cinema-caption--vid-center'
            },





            color: {
                white: 'spa-cinema-caption--vid-white',
                gray: 'spa-cinema-caption--vid-gray',
                blue: 'spa-cinema-caption--vid-blue',
                red: 'spa-cinema-caption--vid-red',
                clear: 'spa-cinema-caption--vid-clear',
                invisible: 'spa-cinema-caption--vid-invisible'
            },





            clickable: 'spa-cinema-caption--vid-clickable'

        };





        utilMergeObjects = function() {


            var
                obj = {},
                i = 0,
                il = arguments.length,
                key;

            for (; i < il; i++) {
                for (key in arguments[i]) {
                    if (arguments[i].hasOwnProperty(key)) {
                        obj[key] = arguments[i][key];
                    }
                }
            }

            return obj;
        };





        populateCinemaCaptions = function(captions) {


            var defaults,
                mapThroughCaptions,
                mapToAnnotations,
                mapCaptionToCreateHTML;

            defaults = captions.options;






            mapThroughCaptions = function(caption, index) {


                var combineDefaultsOptions;

                combineDefaultsOptions = utilMergeObjects({}, defaults, caption.options);
                caption.options = combineDefaultsOptions;

                return caption;

            };






            mapToAnnotations = function(caption, index) {


                var captionClasses;

                captionClasses = [];

                Object.keys(caption.options)
                    .forEach(function(option, index) {

                        if (option === 'classes' || option === 'clickable' || option === 'cta' || option === 'ctaADAText' || option === 'ctaTaggingName' || option === 'layout' || option === 'debug') {
                            return false;
                        }

                        if (option == 'position' && Array.isArray(caption.options[option])) {

                            caption.options[option]
                                .forEach(function(opt, index) {
                                    captionClasses
                                        .push(cinemaCaptionAnnotations[option][opt]);
                                });

                            return false;

                        }

                        captionClasses
                            .push(cinemaCaptionAnnotations[option][caption.options[option]]);

                    });

                caption.options.classes = captionClasses;
                return caption;

            };






            mapCaptionToCreateHTML = function(caption, index) {


                var
                    html,
                    createClickableCaption,
                    nonClickableCaption,
                    createClickableCTA;

                html = '';





                createClickableCaption = function() {

                    html += '<a class="spa-cinema-caption-js" id="' + video.selectorId + '-caption-' + (index + 1) + '" href="' + caption.options.clickable + '" data-options="' + caption.options.classes + '" data-start-time="' + caption.start + '" data-end-time="' + caption.end + '">';
                    html += '<p>' + caption.content + '</p>';
                    html += '<span class="ada-hidden ada-action">Close</span>';
                    html += '</a>';

                };





                nonClickableCaption = function() {

                    html += '<div class="spa-cinema-caption" id="' + video.selectorId + '-caption-' + (index + 1) + '" data-options="' + caption.options.classes + '" data-start-time="' + caption.start + '" data-end-time="' + caption.end + '">';
                    html += '<p>' + caption.content + '</p>';
                    html += '</div>';

                };

                createClickableCTA = function() {

                    html += '<a class="spa-cinema-caption spa-cinema-caption-js spa-cinema-caption-cta' + ((caption.options.debug || (video.overalys && video.overlays.options && video.overlays.options.debug && caption.option.debug !== false)) ? ' spa-cinema-caption-cta--debug' : '') + '" id="' + video.selectorId + '-cta-' + (caption.options.ctaTaggingName ? caption.options.ctaTaggingName : (index + 1)) + '" href="' + caption.options.clickable + '" data-start-time="' + caption.start + '" data-end-time="' + caption.end + '" style="left: ' + caption.options.layout.left + '; top: ' + caption.options.layout.top + '; width: ' + caption.options.layout.width + '; height: ' + caption.options.layout.height + ';" data-options="spa-cinema-caption-cta">';
                    html += '&nbsp;';
                    html += '<span class="ada-hidden">' + caption.options.ctaADAText + '</span>';
                    html += '</a>';

                };


                if (!caption.options.cta) {


                    if (!caption.options.clickable) {

                        nonClickableCaption();
                        return html;
                    }


                    createClickableCaption();
                    return html;
                }

                createClickableCTA();
                return html;
            };

            captions.content = captions.content.map(mapThroughCaptions);
            captions.content = captions.content.map(mapToAnnotations);

            return captions.content.map(mapCaptionToCreateHTML).join('');

        };






        populateCinemaDescription = function(descriptions) {





            var mapThroughDescription = function(description) {
                return '<p>' + description + '</p>';
            };




            return descriptions
                .map(mapThroughDescription).join('');

        };






        populateCinemaTranscript = function(transcripts) {





            var mapThroughTranscripts = function(trancript) {
                return '<p>' + trancript + '</p>';
            };




            return transcripts
                .map(mapThroughTranscripts).join('');

        };

        checkForNonCTACaptions = function(captions) {
            var nonCTAs = false;

            captions.content.forEach(function(current, index, array) {
                if (typeof current.options.cta === 'undefined' || !current.options.cta) {
                    nonCTAs = true;
                }
            });

            return nonCTAs;
        };





        cinemaHTML = '<div class="spa-cinema preloading spa-fn" data-aspect-ratio="' + (video.aspectRatio ? video.aspectRatio : "16:9") + '">';





        cinemaHTML += '<div class="clearfix ' + (video.waitToLoad ? 'spa-cinema-wait' : 'spa-cinema-onload') + ' spa-cinema-wrapper' + (video.backgroundColor == 'white' ? ' spa-cinema-wrapper--white' : '') + (video.backgroundColor == 'transparent' ? ' spa-cinema-wrapper--transparent' : '') + '">';

        if ((poster || video.poster) && video.waitToLoad) {
            cinemaHTML += '<div class="spa-cinema-poster"><img src="' + (poster ? poster : video.poster) + '" /></div>';
        }






        cinemaHTML += '<video id="' + video.selectorId + '" data-setup=\'{"techOrder": ["html5"]}\' data-account="' + (!video.brightCoveAccount ? 1625296048001 : video.brightCoveAccount) + '" data-player="' + (!video.brightCovePlayer ? '0261d90f-ba8d-47eb-b883-d7d68dd58e91"' : video.brightCovePlayer) + '" data-embed="default" data-video-id="' + video.brightCoveVideoId + '" data-tagging-cm="' + (!video.taggingId ? 'coremetricsId' : '') + '" class="video-js spa-cinema-poster--active spa-cinema-video" controls preload="auto"></video>';





        cinemaHTML += '<div class="cinema-captions spa-cinema-captions">' + populateCinemaCaptions((video.captions ? video.captions : (video.overlays ? video.overlays : {}))) + '</div>';





        cinemaHTML += '<div class="spa-cinema-overlays spa-center"> <span id="vid_' + video.brightCoveVideoId + '_playVideo" class="spa-cinema-overlay spa-cinema-overlay--play-' + (!video.playButton ? 'default' : video.playButton) + ' spa-center-absolutely" data-control="play"><span class="ada-hidden">Play video</span></span> <a id="vid_' + video.brightCoveVideoId  + '_replayVideo" href="javascript:void(0);" class="spa-cinema-overlay spa-cinema-overlay--replay spa-center-absolutely" data-control="play" data-opacity="0.9">Replay video</a> <span id="vid_' + video.brightCoveVideoId + '_pauseVideo" class="spa-cinema-overlay spa-cinema-overlay--pause spa-center-absolutely" data-control="pause"><span class="ada-hidden">Pause video</span></span> </div>';
        cinemaHTML += '<div class="spa-cinema-ctrls">' +
            '<div class="motion spa-cinema-ctrl spa-cinema-ctrl--play-pause">' +
            '<a href="javascript:void(0);" id="vid_' + video.brightCoveVideoId + '_playVideo" class="btn-play spa-cinema-btn spa-cinema-btn--play" data-control="play"><span class="ada-hidden">Play video</span></a>' +
            '<a href="javascript:void(0);" id="vid_' + video.brightCoveVideoId + '_playVideo" class="btn-replay spa-cinema-btn spa-cinema-btn--replay" data-control="play"><span class="ada-hidden">Replay video</span></a>' +
            '<a href="javascript:void(0);" id="vid_' + video.brightCoveVideoId + '_pauseVideo" class="btn-pause spa-cinema-btn spa-cinema-btn--pause" data-control="pause"><span class="ada-hidden">Pause video</span></a>' +
            '</div>' +
            '<div role="application" class="range-slider spa-cinema-ctrl spa-cinema-ctrl--timeline" data-slider data-display="time" data-control="time">' +
            '<span tabindex="0" class="spa-cinema-scrubber spa-cinema-scrubber--light range-slider-handle"><span class="ada-hidden">To video progress: Press left and right arrow keys to fast forward or backward</span></span>' +
            '<span class="range-slider-active-segment">&nbsp;</span>' +
            '<input type="hidden">' +
            '</div>' +
            '<div class="control-button-grp"><div class="spa-cinema-ctrl spa-cinema-ctrl--timecodes" data-display="time">' +
            '<span class="spa-cinema-timecode spa-cinema-timecode--current">' +
            '<em>0:00</em>' +
            '</span>' +
            ' / ' +
            '<span class="spa-cinema-timecode spa-cinema-timecode--total">' +
            '<em>0:00</em>' +
            '</span>' +
            '</div>';

             if (checkForNonCTACaptions((video.captions ? video.captions : video.overlays))) {
            cinemaHTML +=
                '<div class="spa-cinema-ctrl spa-cinema-ctrl--captions">' +
                '<a href="javascript:void(0);" id="vid_' + video.brightCoveVideoId + '_hideCaptions" class="spa-cinema-btn spa-cinema-btn--captions spa-cinema-btn--on" data-control="captions-on">' +
                ' <span class="ada-hidden">Disable Closed Captioning</span>' +
                '</a>' +
                '<a href="javascript:void(0);" id="vid_' + video.brightCoveVideoId + '_showCaptions" class="spa-cinema-btn spa-cinema-btn--captions spa-cinema-btn--off" data-control="captions-off">' +
                ' <span class="ada-hidden">Enable Closed Captioning</span>' +
                '</a>' +
                '</div>';
        }

            cinemaHTML += '<div role="application" class="spa-cinema-ctrl spa-cinema-ctrl--volume" data-display="volume">' +
            '<a href="javascript:void(0);" id="vid_' + video.brightCoveVideoId + '_unMuteVideo" class="two-thirds-volume volume-adjust spa-cinema-btn spa-cinema-btn--no-bg spa-cinema-btn--volume">' +
            ' <span class="ada-hidden">To Adjust Volume: Press Enter to activate volume control then use the UP and DOWN arrow keys to adjust the volume</span>' +
            '</a>' +
            '<div class="range-slider vertical-range spa-cinema-volume spa-cinema-ctrl--volume-bar" data-control="volume" data-slider data-options="vertical: true;">' +
            '<span class="total"><span class="ada-hidden"><em>100</em>% volume</span></span>' +
            '<span class="current"><span class="ada-hidden"><em>50</em>% volume</span></span>' +
            '<span class="range-slider-handle spa-cinema-scrubber spa-cinema-scrubber--dark">&nbsp;</span>' +
            '<span class="range-slider-active-segment">&nbsp;</span>' +
            '<input type="hidden">' +
            '</div>' +
            '</div>' +
            '<div class="spa-cinema-ctrl spa-cinema-ctrl--fullscreen">' +
            '<a id="vid_' + video.brightCoveVideoId + '_fullScreen" class="spa-cinema-btn spa-cinema-btn--fullscreen" data-control="fullscreen" href="javascript:void(0);">' +
            '<span class="ada-hidden">Show video in full screen</span>' +
            '</a>' +
            '</div>';


        cinemaHTML += '</div></div>';





        cinemaHTML += '</div>';





        cinemaHTML += '<div class="spa-cinema-metadata' + (video.backgroundColor == 'white' ? ' spa-cinema-metadata--white' : '') + (video.backgroundColor == 'transparent' ? ' spa-cinema-metadata--transparent' : '') + '">';

        if (!video.hideTitle) {
            cinemaHTML += '<h2 class="spa-cinema-metadata--title" data-font="cnx-regular">' + (!video.description.title ? '' : video.description.title) + '</h2>';
        }





        if (!video.hideDescription) {
            cinemaHTML += '<div class="spa-cinema-metadata--description">';
            cinemaHTML += (!video.description.content ? '' : populateCinemaDescription(video.description.content));
            cinemaHTML += '</div>';
        }





        if (video.transcripts || video.secondaryLink) {

            cinemaHTML += '<ul class="spa-cinema-metadata--options">';

            if (video.secondaryLink) {
                cinemaHTML += '<li class="spa-cinema-metadata--link-secondary left arrow">';
                cinemaHTML += '<a id="' + video.selectorId + '-secondary" href="' + video.secondaryLink + '">Secondary link</a>';
                cinemaHTML += '</li>';
            }

            if (video.transcripts) {

                cinemaHTML += '<li class="spa-cinema-metadata--link-transcript">';
                cinemaHTML += '<a id="' + video.selectorId + '-toggle-transcript" href="#' + video.selectorId + '-video-transcript" class="spa-cinema-view-transcript"><div class="spa-arrow-btn--toggle"><div class="spa-arrow-btn spa-arrow-btn--blue spa-arrow-btn--learn-more">&nbsp;</div></div><span class="spa-cinema--transcript-status">View Transcript</span><span class="ada-hidden">Transcript Collapsed</span></a>';
                cinemaHTML += '</li>';

            }

            cinemaHTML += '</ul>';

        }





        cinemaHTML += '<div class="spa-cinema-metadata--transcript" id="' + video.selectorId + '-video-transcript">';

        cinemaHTML += '<h3>Transcript</h3>';
        cinemaHTML += (!video.transcripts ? '' : populateCinemaTranscript(video.transcripts));





        cinemaHTML += '</div>';





        cinemaHTML += '</div>';





        cinemaHTML += '</div>';

        cinemaHTML += '<script src="https://players.brightcove.net/'+ (!video.brightCoveAccount ? 1625296048001 : video.brightCoveAccount) + '/' + (!video.brightCovePlayer ? '0261d90f-ba8d-47eb-b883-d7d68dd58e91"' : video.brightCovePlayer) + '_default/index.min.js"></script>';




        return cinemaHTML;

    }

};


module.exports.register = function(Handlebars, options) {
    options = options || {};
    for (var helper in helpers) {
        if (helpers.hasOwnProperty(helper)) {
            Handlebars.registerHelper(helper, helpers[helper]);
        }
    }
};


module.exports.helpers = helpers;
